"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TogglerContainer = exports.SwitcherIconContainer = exports.SwitcherHeaderTitle = exports.SwitcherHeader = exports.Switcher = exports.SitemapWrapper = exports.SitemapDropdownContainer = exports.MenuToggler = exports.LogoInner = exports.LogoContainer = exports.Logo = exports.ExpandedMenuLabel = exports.ExpandedMenuItem = exports.ExpandedMenu = exports.DropdownItemLabel = exports.DropdownItem = exports.DropdownInner = exports.DropdownContainer = exports.ControlsContainer = exports.ClickOutside = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ClickOutside = _interopRequireDefault(require("../../../../components/ClickOutside"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const logoWidth = 135;
const togglerWidth = 56;
const logoIndent = 70;
const switcherLeftIndent = logoWidth + togglerWidth + logoIndent;
const ControlsContainer = exports.ControlsContainer = _styledComponents.default.div.withConfig({
  displayName: "mds__ControlsContainer",
  componentId: "sc-14xa07g-0"
})(["align-items:center;height:100%;position:relative;flex:1;display:flex;min-width:0;"]);
const TogglerContainer = exports.TogglerContainer = _styledComponents.default.div.withConfig({
  displayName: "mds__TogglerContainer",
  componentId: "sc-14xa07g-1"
})(["flex-shrink:0;width:", "px;height:48px;transition:margin-right 0.3s ease-in-out;"], togglerWidth);
const MenuToggler = exports.MenuToggler = _styledComponents.default.div.withConfig({
  displayName: "mds__MenuToggler",
  componentId: "sc-14xa07g-2"
})(["cursor:pointer;width:100%;height:100%;z-index:100;position:relative;& span{bottom:auto;left:50%;right:auto;top:50%;transform:translateX(-50%) translateY(-50%);position:absolute;width:24px;height:1px;background-color:", ";border-radius:24px;&:before,&:after{content:'';width:24px;height:1px;background-color:", ";position:absolute;border-radius:24px;}&:before{transform:translateY(-7px);}&:after{transform:translateY(7px);}}"], ({
  theme
}) => theme.colors.appFrame.header.menuTogglerBg, ({
  theme
}) => theme.colors.appFrame.header.menuTogglerBg);
const LogoContainer = exports.LogoContainer = _styledComponents.default.div.withConfig({
  displayName: "mds__LogoContainer",
  componentId: "sc-14xa07g-3"
})(["flex-shrink:0;", ""], ({
  collapsedMenu
}) => collapsedMenu && (0, _styledComponents.css)(["border-right:1px solid ", ";padding-right:16px;padding-left:16px;"], ({
  theme
}) => theme.colors.appFrame.header.logoBorder));
const LogoInner = exports.LogoInner = _styledComponents.default.div.withConfig({
  displayName: "mds__LogoInner",
  componentId: "sc-14xa07g-4"
})(["width:", "px;height:32px;"], logoWidth);
const Logo = exports.Logo = _styledComponents.default.div.withConfig({
  displayName: "mds__Logo",
  componentId: "sc-14xa07g-5"
})(["background-image:url(", ");background-size:contain;background-repeat:no-repeat;background-position:center;flex:1 1 0%;width:100%;height:100%;cursor:", ";"], ({
  logo
}) => logo, ({
  isLink
}) => isLink ? 'pointer' : 'default');
const Switcher = exports.Switcher = _styledComponents.default.div.withConfig({
  displayName: "mds__Switcher",
  componentId: "sc-14xa07g-6"
})(["height:100%;position:relative;flex:1;min-width:0;overflow:", ";", ""], ({
  isExpandedMenuHidden
}) => isExpandedMenuHidden ? 'hidden' : 'auto', ({
  expanded
}) => expanded && (0, _styledComponents.css)(["overflow:unset;position:absolute;top:0;right:0;left:", "px;"], switcherLeftIndent));
const SwitcherHeader = exports.SwitcherHeader = _styledComponents.default.div.withConfig({
  displayName: "mds__SwitcherHeader",
  componentId: "sc-14xa07g-7"
})(["cursor:pointer;display:flex;flex-direction:row;align-items:center;margin:0 16px;height:100%;max-width:fit-content;&:hover{padding-top:4px;color:", ";border-bottom:", ";}", ""], ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor, ({
  theme
}) => `solid 4px ${theme.colors.appFrame.header.switcherActiveItemBorderColor}`, ({
  isOpen
}) => isOpen && (0, _styledComponents.css)(["padding-top:4px;color:", ";border-bottom:", ";"], ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor, ({
  theme
}) => `solid 4px ${theme.colors.appFrame.header.switcherActiveItemBorderColor}`));
const SwitcherIconContainer = exports.SwitcherIconContainer = _styledComponents.default.div.withConfig({
  displayName: "mds__SwitcherIconContainer",
  componentId: "sc-14xa07g-8"
})([""]);
const SwitcherHeaderTitle = exports.SwitcherHeaderTitle = _styledComponents.default.h1.withConfig({
  displayName: "mds__SwitcherHeaderTitle",
  componentId: "sc-14xa07g-9"
})(["font-size:16px;line-height:24px;font-weight:300;"]);
const DropdownContainer = exports.DropdownContainer = _styledComponents.default.div.withConfig({
  displayName: "mds__DropdownContainer",
  componentId: "sc-14xa07g-10"
})(["position:absolute;background-color:", ";box-shadow:0 6px 12px rgba(0,0,0,0.3);padding:16px 0;z-index:300;overflow-y:auto;max-height:350px;"], ({
  theme
}) => theme.colors.appFrame.header.switcherDropdownBg);
const SitemapDropdownContainer = exports.SitemapDropdownContainer = (0, _styledComponents.default)(DropdownContainer).withConfig({
  displayName: "mds__SitemapDropdownContainer",
  componentId: "sc-14xa07g-11"
})(["box-shadow:0 3px 5px 0 ", ";max-height:550px;padding:0;", ""], ({
  theme
}) => theme.colors.appFrame.menu.switcherShadow, ({
  left,
  top
}) => (0, _styledComponents.css)(["left:calc(", "px - ", "px);top:", "px;"], left, switcherLeftIndent, top));
const SitemapWrapper = exports.SitemapWrapper = _styledComponents.default.div.withConfig({
  displayName: "mds__SitemapWrapper",
  componentId: "sc-14xa07g-12"
})(["display:contents;cursor:pointer;"]);
const DropdownInner = exports.DropdownInner = _styledComponents.default.div.withConfig({
  displayName: "mds__DropdownInner",
  componentId: "sc-14xa07g-13"
})(["::-webkit-scrollbar{-webkit-appearance:none;width:7px;}::-webkit-scrollbar-thumb{right:7px;border-radius:4px;background-color:rgba(0,0,0,.5);-webkit-box-shadow:0 0 1px rgba(255,255,255,.5);}"]);
const DropdownItem = exports.DropdownItem = _styledComponents.default.div.withConfig({
  displayName: "mds__DropdownItem",
  componentId: "sc-14xa07g-14"
})(["cursor:pointer;padding:10px 30px;"]);
const DropdownItemLabel = exports.DropdownItemLabel = _styledComponents.default.a.withConfig({
  displayName: "mds__DropdownItemLabel",
  componentId: "sc-14xa07g-15"
})(["font-family:", ";font-size:16px;font-weight:300;line-height:24px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:inline;color:", ";&:hover{color:", ";border-bottom:2px solid ", ";}"], ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.colors.appFrame.header.switcherLinkColor, ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor, ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor);
const ClickOutside = exports.ClickOutside = (0, _styledComponents.default)(_ClickOutside.default).withConfig({
  displayName: "mds__ClickOutside",
  componentId: "sc-14xa07g-16"
})(["height:100%;"]);
const ExpandedMenu = exports.ExpandedMenu = _styledComponents.default.ul.withConfig({
  displayName: "mds__ExpandedMenu",
  componentId: "sc-14xa07g-17"
})(["list-style:none;display:flex;align-items:center;padding:0 16px;height:100%;visibility:", ""], ({
  $hidden
}) => $hidden ? 'hidden' : 'visible');
const ExpandedMenuItem = exports.ExpandedMenuItem = _styledComponents.default.li.withConfig({
  displayName: "mds__ExpandedMenuItem",
  componentId: "sc-14xa07g-18"
})(["color:", ";align-items:center;display:flex;margin:0 12px;height:100%;position:relative;overflow:hidden;&:hover{color:", ";&:after{content:'';background-color:", ";display:block;height:4px;width:100%;position:absolute;bottom:0;}}", ""], ({
  theme
}) => theme.colors.appFrame.header.switcherLinkColor, ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor, ({
  theme
}) => theme.colors.appFrame.header.switcherActiveItemBorderColor, ({
  active
}) => active && (0, _styledComponents.css)(["color:", ";&:after{content:'';background-color:", ";display:block;height:4px;width:100%;position:absolute;bottom:0;}"], ({
  theme
}) => theme.colors.appFrame.header.switcherLinkHoverColor, ({
  theme
}) => theme.colors.appFrame.header.switcherActiveItemBorderColor));
const ExpandedMenuLabel = exports.ExpandedMenuLabel = _styledComponents.default.a.withConfig({
  displayName: "mds__ExpandedMenuLabel",
  componentId: "sc-14xa07g-19"
})(["color:inherit;font-family:", ";font-size:16px;font-weight:300;cursor:pointer;overflow:hidden;text-overflow:ellipsis;text-wrap:nowrap;}"], ({
  theme
}) => theme.fonts.preferred);